import React, { useMemo } from "react"
import { Button, Flex, FormItemProps, Typography } from "antd"
import { Form } from "antd"
import { QuestionCircleOutlined } from "@ant-design/icons"
import Tippy from "@tippyjs/react"

type Props = {
  children: React.ReactElement
  optional?: boolean
  tooltip?: React.ReactElement | string
} & FormItemProps

export const FormItemUi = (props: Props) => {
  const tool = useMemo(() => {
    return props.tooltip ? (
      <Tippy content={props.tooltip}>
        <QuestionCircleOutlined />
      </Tippy>
    ) : null
  }, [props.tooltip])

  const label = useMemo(() => {
    return (
      <Typography.Text>
        <Flex gap={4}>
          {props.label}
          {props.optional && <span style={{ opacity: 0.5 }}>(optional)</span>}
          {tool}
        </Flex>
      </Typography.Text>
    )
  }, [props.label, props.optional, tool])

  return (
    <Form.Item {...props} label={label}>
      {props.children}
    </Form.Item>
  )
}
